import { useEffect, useState } from "react";
import { api, API } from "../lib/api";
import { FileText, Mail } from "lucide-react";

export default function StatementsPanel() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/gigs/business/statements").then((r) => setRows(r.data)).catch(() => {}); }, []);
  if (rows.length === 0) return null;
  return (
    <div className="p-4 rounded-2xl bg-[#131722] border border-slate-800" data-testid="statements-panel">
      <p className="text-xs font-mono uppercase tracking-widest text-slate-400 flex items-center gap-1.5 mb-2"><FileText className="w-3.5 h-3.5 text-cyan-400" />Monthly statements</p>
      <ul className="divide-y divide-slate-800">
        {rows.slice(0, 6).map((r) => (
          <li key={r.month} className="py-2 flex items-center gap-3 text-sm" data-testid={`statement-${r.month}`}>
            <span className="font-mono text-slate-300 w-20">{new Date(r.month + "-02").toLocaleDateString([], { month: "short", year: "numeric" })}</span>
            <span className="text-xs text-slate-500 flex-1">{r.jobs} deliveries · ${r.spend.toFixed(2)}{r.emailed_at && <Mail className="w-3 h-3 inline ml-1.5 text-emerald-400" title="Emailed" />}</span>
            <a href={`${API}/gigs/business/statements/${r.month}.pdf`} target="_blank" rel="noreferrer" data-testid={`statement-pdf-${r.month}`} className="text-xs text-cyan-300 hover:underline">PDF</a>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-slate-500 mt-2">Statements are emailed automatically on the 1st of each month.</p>
    </div>
  );
}
